import { render, staticRenderFns } from "./orgProductDialog.vue?vue&type=template&id=1f296a72&scoped=true"
import script from "./orgProductDialog.vue?vue&type=script&lang=js"
export * from "./orgProductDialog.vue?vue&type=script&lang=js"
import style0 from "./orgProductDialog.vue?vue&type=style&index=0&id=1f296a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f296a72",
  null
  
)

export default component.exports